module.exports = __webpack_public_path__ + "static/team-21893474dc59ed2d11a9d3a82a437453.svg";